import { render, staticRenderFns } from "./coastal_warning.vue?vue&type=template&id=e4a95aee&scoped=true&"
import script from "./coastal_warning.vue?vue&type=script&lang=js&"
export * from "./coastal_warning.vue?vue&type=script&lang=js&"
import style0 from "./coastal_warning.vue?vue&type=style&index=0&id=e4a95aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a95aee",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e4a95aee', component.options)
    } else {
      api.reload('e4a95aee', component.options)
    }
    module.hot.accept("./coastal_warning.vue?vue&type=template&id=e4a95aee&scoped=true&", function () {
      api.rerender('e4a95aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/monitor/ntpc/coastal_warning.vue"
export default component.exports